module.exports = __webpack_public_path__ + "img/pencil-outline-houver.5b260a5a.svg";